<template>
  <div class="step-breadcrumb">
    <ul :class="'skin-'+skin">
      <li v-for="(step,index) of detail" :key="index"
          :class="{active:stepIndex===index+1,
          enabled:index===0&&stepIndex!==1||index===1&&stepIndex===3
          }"
          @click="stepChange(index+1)">
        <span v-text="step"/>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    stepIndex: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      detail: [
        this.$t('Search'),
        this.$t('Select Room'),
        this.$t('Payment'),
        this.$t('Confirmation')
      ]
    };
  },
  methods: {
    stepChange(index) {
      if (index === 1) {
        const other = {
          lang: this.$route.query.lang || localStorage.lang
        }
        let query = Object.assign({ 'skin': this.skin }, other)
        this.$router.push({
          'name': 'Home',
          query
        })

      } else if (index === 2 && this.stepIndex === 3) {
        let query = Object.assign({ 'skin': this.skin }, this.$route.query)
        delete query.submit
        this.$router.push({
          'name': 'SelectRoom',
          query
        })
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.step-breadcrumb {
  ul {
    height: 94px;
    display: flex;
    justify-content: center;
    align-items: center;
    counter-reset: num;
    li {
      display: flex;
      align-items: center;
      font-weight: bold;

      &:before {
        content: counter(num);
        counter-increment: num;
        display: block;
        width: 35px;
        height: 35px;
        background: #707070;
        border-radius: 50%;
        text-align: center;
        line-height: 35px;
        color: white;
        font-size: 18px;
        margin-left: 20px;
      }

      &:after {
        content: "\00bb";
        font-size: 20px;
      }

      span {
        margin: 0 20px;
        font-size: 15px;
        color: #707070;
      }

      &:last-child {
        &:after {
          display: none;
        }
      }

      &.active {
        &:before {
          background: #2d6d71;
          color: white;
        }

        span {
          color: #a8996e;
        }
      }

      &.enabled {
        cursor: pointer
      }
    }
  }

  @media (max-width: 767px) {
    display: none;
  }
}
</style>
